export { OrderDetailsPage } from './view/order-details-page';

export { default as orderDetailSlice } from './slice';
export { orderDetailSagas } from './sagas';
export * from './types';
